import { render } from "./CrInfo.vue?vue&type=template&id=35dfd9b2&scoped=true"
import script from "./CrInfo.vue?vue&type=script&lang=js"
export * from "./CrInfo.vue?vue&type=script&lang=js"

import "./CrInfo.vue?vue&type=style&index=0&id=35dfd9b2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35dfd9b2"]])

export default __exports__